import React, {useState, useEffect, Fragment} from 'react'
import {Form, Input, Row, Col, Button, Tabs, DatePicker} from 'antd';
import {listFormItemLayout,} from '../../utills/common'
import AllTable from './all-table'

const {TabPane} = Tabs;
const {RangePicker} = DatePicker;

function DomesticOrderList(props) {
    const [currentKey, setCurrentKey] = useState('commit');//当前选项卡
    const [criteria, setCriteria] = useState({});//查询条件
    const {getFieldDecorator} = props.form;

    const callback = (key) => {
        setCurrentKey(key);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setCriteria(props.form.getFieldsValue());
    };
    return <div className='box-shadow padding-20'>
        <div className='head-title'>国内运输订单</div>
        <br/>
        <Form {...listFormItemLayout} onSubmit={handleSubmit}>
            <Row>
                <Col span={8}>
                    <Form.Item label="订单编号">
                        {getFieldDecorator('orderNo', {})(<Input/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="车牌">
                        {getFieldDecorator('vehicleNo', {})(<Input/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="起运地">
                        {getFieldDecorator('departure', {})(<Input/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="目的地">
                        {getFieldDecorator('destination', {})(<Input/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="提货时间">
                        {getFieldDecorator('collectDt', {})(<RangePicker format="YYYY-MM-DD"
                                                                         style={{width: '100%'}}/>)}
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label="发运时间">
                        {getFieldDecorator('sendDt', {})(<RangePicker format="YYYY-MM-DD"
                                                                      style={{width: '100%'}}/>)}
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Button className='margin-btn-last' type='primary' htmlType="submit"
                            style={{float: 'right'}}>查询</Button>
                    <Button className='margin-btn' htmlType="button" style={{float: 'right'}}
                            onClick={() => props.history.push('/domesticOrder')}>新增</Button>
                </Col>
            </Row>
        </Form>
        <Tabs onChange={callback} defaultActiveKey="commit">
            <TabPane tab="已下单" key="commit">
                <AllTable status='commit' currentKey={currentKey} criteria={criteria} history={props.history}/>
            </TabPane>
            <TabPane tab="审核失败" key="failed">
                <AllTable status='failed' currentKey={currentKey} criteria={criteria} history={props.history}/>
            </TabPane>
            <TabPane tab="已审核" key="pass">
                <AllTable status='pass' currentKey={currentKey} criteria={criteria} history={props.history}/>
            </TabPane>
            <TabPane tab="已上门" key="collect">
                <AllTable status='collect' currentKey={currentKey} criteria={criteria} history={props.history}/>
            </TabPane>
            <TabPane tab="运输中" key="send">
                <AllTable status='send' currentKey={currentKey} criteria={criteria} history={props.history}/>
            </TabPane>
            <TabPane tab="已抵达" key="arrive">
                <AllTable status='arrive' currentKey={currentKey} criteria={criteria} history={props.history}/>
            </TabPane>
            <TabPane tab="已取消" key="cancelled">
                <AllTable status='cancelled' currentKey={currentKey} criteria={criteria} history={props.history}/>
            </TabPane>
            <TabPane tab="全部订单" key="all">
                <AllTable status='' currentKey={currentKey} criteria={criteria} history={props.history}/>
            </TabPane>
        </Tabs>
    </div>
}

export default Form.create()(DomesticOrderList);